module.exports = __webpack_public_path__ + "img/product-image-not-found.jpg";